var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"elApp",attrs:{"id":"app"}},[_c('vue-headful',{attrs:{"title":this.$PRJ_FULLNAME}}),_c('fish-layout',{ref:"elLayout"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }